import AdLayout from "../../app-core/AdLayout";
import DropTablesNav from "./DropTablesNav";
import LootGrid from "../LootGrid";
import * as T from "common/src/bindings/Translation2";
import {
  Provider as TftSetProvider,
  fromNum,
} from "common/src/data/TftSet.bs.js";

type Tables = Array<{
  idx: number;
  breakpoint: number;
  value: number;
  options: Array<[number, Array<any>]>;
}>;
export default function CypherTables({ tables }: { tables: Tables }) {
  return (
    <AdLayout>
      <TftSetProvider.make value={fromNum(140)}>
        <div className="flex flex-col bg-bg rounded w-full md:w-[928px] pb-4">
          <DropTablesNav route={"Cypher"} />
          <h2 className="h2 p-4 pb-0 flex items-center gap-1">
            {T.traits("TFT14_Suits") + " " + T.common("Rewards")}
          </h2>
          {tables.map(({ breakpoint, value, options, idx }) => {
            return (
              <div key={idx}>
                <h3 className="pt-12 px-4 pb-5 h4 leading-tight">{`${breakpoint} Intel (${value}g)`}</h3>
                <LootGrid data={options} />
              </div>
            );
          })}
        </div>
      </TftSetProvider.make>
    </AdLayout>
  );
}
